import { SET_POST_DATA } from "../actions/action";

const initialState = {
    postdata: [],
};

const postReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_POST_DATA: 
        return {
            ...state,
            postdata: action.payload.postdata,
        };
        default:
            return state;
    }
};

export default postReducer;